<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  isOpen: { type: Boolean, default: false },
});

const isExpanded = ref(props.isOpen);

const toggleAccordion = () => {
  isExpanded.value = !isExpanded.value;
};

watch(
  () => props.isOpen,
  newValue => {
    isExpanded.value = newValue;
  }
);
</script>

<template>
  <div class="flex flex-col items-start w-full gap-2">
    <button
      type="button"
      class="flex items-center justify-between w-full pb-2 border-b border-n-slate-4"
      @click="toggleAccordion"
    >
      <span class="text-base font-semibold uppercase text-n-slate-12">
        {{ title }}
      </span>
      <span
        class="w-5 h-5 transition-transform duration-200 i-lucide-chevron-down text-n-slate-11"
        :class="{ 'rotate-180': isExpanded }"
      />
    </button>
    <div v-if="isExpanded" class="w-full">
      <slot />
    </div>
  </div>
</template>
